import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import ArrowIcon from "./icon-arrow.svg";

export const StyledArrowIcon = styled(ArrowIcon)`
  display: block;

  margin-inline-start: 4px;
`;

type ContainerProps = {
  $isLink: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  gap: 8px;
  align-items: center;

  margin-block-end: 20px;
  padding-block: 4px;
  padding-inline: 8px;

  color: #ffffff;
  font-weight: 700;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  text-transform: uppercase;

  border-radius: 4px;

  background-color: #30343c;

  cursor: ${props => (props.$isLink ? "pointer" : "default")};
`;

export const Title = styled.div``;
